import {
	FEATURE_FLAG_ENVIRONMENT_RANK,
	type FeatureFlagEnvironment,
} from './feature-flag.types';

// The frontend's own hosting domains (see apps/hela/_cloud/aws/readme.md) —
// not API/gateway hosts. Anything else, including qgenonlinedev.com's own
// preview subdomains that don't match, falls back to 'local'.
const PRODUCTION_HOST = 'qgenonline.com';
const DEV_HOST = 'qgenonlinedev.com';

function matchesHost(hostname: string, host: string): boolean {
	return hostname === host || hostname.endsWith(`.${host}`);
}

function environmentForHostname(hostname: string): FeatureFlagEnvironment {
	if (matchesHost(hostname, PRODUCTION_HOST)) return 'production';
	if (matchesHost(hostname, DEV_HOST)) return 'dev';
	return 'local';
}

/**
 * Cross-checks the build-time environment against the domain the app is
 * actually running on. A container deployed with the wrong ENVIRONMENT
 * value baked in must never resolve MORE permissively than its real domain
 * allows — this only ever tightens the result (raises it toward
 * 'production'), it never loosens a build environment that is already
 * stricter than the domain suggests.
 */
export function reconcileFeatureFlagEnvironment(
	buildEnvironment: FeatureFlagEnvironment,
	hostname: string
): FeatureFlagEnvironment {
	const hostEnvironment = environmentForHostname(hostname);
	return FEATURE_FLAG_ENVIRONMENT_RANK[hostEnvironment] >
		FEATURE_FLAG_ENVIRONMENT_RANK[buildEnvironment]
		? hostEnvironment
		: buildEnvironment;
}
